import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import getAccess from '../../../utils/getAccess';
import ChannelTable from './ChannelTable';
import AddChannel from './AddChannel';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Channel = () => {
  const access = getAccess();
  // console.log(access);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{ width: '100%', }}>
        {((access?.accessForTab?.includes('read') &&  access?.access?.includes('8881') )|| access?.access?.includes('all')  ) && ( <Tab label="All Channel" sx={{ width: '100%' }} {...a11yProps(0)} />)}
          
          {((access?.accessForTab?.includes('readWrite') &&  access?.access?.includes('8882') )|| access?.access?.includes('all') )  && (<Tab label="Add Channel" sx={{ width: '100%' }} {...a11yProps(1)} /> )}
        </Tabs>
      </Box>
      {((access?.accessForTab?.includes('read') &&  access?.access?.includes('8881') )|| access?.access?.includes('all') ) && ( <TabPanel value={value} index={0}>
         <ChannelTable />
      </TabPanel>)}
      {((access?.accessForTab?.includes('readWrite') &&  access?.access?.includes('8882') )|| access?.access?.includes('all') )  && (<TabPanel value={value} index={1}>
         <AddChannel />
      </TabPanel>)}

    </Box >
  );
}

export default Channel